export default __webpack_public_path__ + "static/media/Summoner's Helm of the Emperor's Favor.6787c5f0.jpg";